module.exports = __webpack_public_path__ + "static/media/marinatognetti.3e50f4c4.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/marinatognetti.webp
// module id = 519
// module chunks = 0